export const ADD_PAYMENT_METHODS = 'ADD_PAYMENT_METHODS';
export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD';
export const SET_DEFAULT_PAYMENT = 'SET_DEFAULT_PAYMENT';
export const SET_DELETE_CREDIT_CARD = 'SET_DELETE_CREDIT_CARD';
export const SET_VANTIV_RESPONSE = 'SET_VANTIV_RESPONSE';
export const SET_VANTIV_RESPONSE_EMPTY = 'SET_VANTIV_RESPONSE_EMPTY';

export const FULFILLED_STATUS = 'fulfilled';
